import React, { useRef } from 'react';
import { ProTable } from 'react-pro-components';
import { ProTableProps } from 'react-pro-components/typings/components/pro-table/types';
import { Button, message, Spin } from 'ssc-ui-react';

import { $gt, VueCtxRouter } from '@/common/appCtx';

import { usePermissions } from '../permissions';
import { MassActions } from './components/actions';
import BatchImportDialog from './components/batch-import-dialog';
import { useTableConfigs } from './hooks/use-batch-configs';
import { useBatchData } from './hooks/use-batch-data';
import useBatchImport from './hooks/use-batch-import';
import { useInitBreadcrumb } from './hooks/use-init-breadcrumb';
import style from './index.module.less';

export default function BatchImportListPage() {
  const importButtonRef = useRef<any>(null);
  const hasPermission = usePermissions();
  const {
    dataSource,
    setDataSource,
    pagination,
    setPagination,
    summary,
    setSummary,
    list,
  } = useBatchData();
  const tableConfigs = useTableConfigs();
  const { batchImportDialogProps, batchImportButtonProps } = useBatchImport({
    importFile: tableConfigs.reqConfig.httpImportFile
  });
  useInitBreadcrumb();

  const handleRetry = () => {
    importButtonRef.current?.click();
  };

  const emptyText = batchImportDialogProps.importError ? (
    <div className={style.batchImportRetry}>
      {$gt('Import Failed. Please ')}<span onClick={handleRetry}>{$gt('Retry')}</span>
    </div>
  ) : undefined;

  const handleImportConfirm = (nv: any[], newSummary: any) => {
    setDataSource(nv);
    setSummary(newSummary);
    const total = nv.length;
    setPagination(state => ({
      ...state,
      current: 1,
      total,
    }));
  };

  const onDownloadRes = () => {
    if (dataSource.length < 1) {
      message.warn($gt('No Data'));
      return;
    }
    tableConfigs.reqConfig.downloadRes({ list: dataSource });
  };

  const proTableProps: ProTableProps = {
    operation: <MassActions
      title={tableConfigs.title}
      onDownloadTemplate={tableConfigs.reqConfig.downloadTemplate}
      onDownloadRes={onDownloadRes}
      batchImportButtonProps={batchImportButtonProps}
      summary={summary}
      ref={importButtonRef}
    />,
    table: {
      dataSource: list,
      columns: tableConfigs.columns,
      pagination,
      emptyText,
    },
    fetchData: async (info) => {
      const newPageNation = info?.pagination;
      newPageNation && setPagination(newPageNation);
    },
  };

  const handleSubmit = () => {
    const list = dataSource.filter((item) => {
      return item.upload_result === 'SUCCESS';
    });
    tableConfigs.reqConfig.submitFile({ list });
  };

  const hanledCancel = () => {
    VueCtxRouter.push('/workstation-information');
  };

  if (!hasPermission('workstationBatchAction')) {
    return null;
  }
  return (
    <div className={style.massContainer}>
    <Spin
      size="large"
      spinning={tableConfigs.reqConfig.submitLoading}
      mask
    >
      <ProTable {...proTableProps} />
      <BatchImportDialog {...batchImportDialogProps} handleRetry={handleRetry} handleImportConfirm={handleImportConfirm} />
      <div className={style.footerContainer}>
        <Button onClick={hanledCancel}>{ $gt('Cancel') }</Button>
        <Button type="primary" onClick={handleSubmit}>{$gt('Confirm')}</Button>
      </div>
    </Spin>
    </div>
  );
}
